import React from "react"
import { graphql, StaticQuery } from "gatsby"
import styled from '@emotion/styled';
import { darkThemeColors } from '../util/styles';

/**
 * Container for all products
 */
const NewsListing = (props) => (
    <StaticQuery
        query={graphql`
            query NewsItems {
                newsItems: allMarkdownRemark(filter: {frontmatter: {templateKey: {eq: "news-page"}}}) {
                edges {
                    node {
                    fields {
                        slug
                    }
                    id
                    frontmatter {
                        title
                        description
                        }
                    }
                }
            }
        }          
    `}
        render={({ newsItems }) => (
            <>
                <Heading>News</Heading>
                {newsItems.edges.map(({ node: news }) => (
                    <div key = {news.title}>
                        {news.frontmatter.title}
                        {news.frontmatter.description}
                    </div>
                )
                )
                }
            </>
        )}
    />
);

const Heading = styled(`div`)`
  font-family: Lato,'Helvetica Neue',Arial,Helvetica,sans-serif;
  line-height: 1.3;
  font-size: 1.6rem;
  font-weight: 500;
  color: ${darkThemeColors.lightest};   
`

export default NewsListing;
